export * from './ArrowCUpIcon';
export * from './ArrowCUpIcon16Light';
export * from './ArrowCUpIcon16Regular';
export * from './ArrowCUpIcon16Solid';
export * from './ArrowCUpIcon20Light';
export * from './ArrowCUpIcon20Regular';
export * from './ArrowCUpIcon20Solid';
export * from './ArrowCUpIcon24Regular';
export * from './ArrowCUpIcon24Solid';
export * from './ArrowCUpIcon32Regular';
export * from './ArrowCUpIcon64Regular';
